import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  headerText: {
    margin: theme.spacing(1, 0),
    color: '#999',
    fontWeight: '600',
    fontSize: '.9rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));
